import { render, staticRenderFns } from "./billing-center.vue?vue&type=template&id=5f6db905&scoped=true&"
import script from "./billing-center.vue?vue&type=script&lang=js&"
export * from "./billing-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6db905",
  null
  
)

export default component.exports